import { Flex } from "@gravity-ui/uikit";
import {
  ProductDetailResponseDto,
  ProductSourceDtoSourceEnum,
} from "definitions/product-storage";

import { PriceProps } from "../../../../PriceProps";
import { ProductContentDescription } from "../ProductContentDescription";
import { ProductInfo } from "../ProductInfo";
import { ProductPriceDetails } from "../ProductPriceDetails";
import { ProductPriceSource } from "../ProductPriceSource";
import css from "./ProductDesktopLayout.module.scss";

export interface ProductDesktopLayoutProps {
  product: ProductDetailResponseDto;
  source: ProductDetailResponseDto["productSources"];
  platform: null | ProductSourceDtoSourceEnum;
  setPlatform: (platform: null | ProductSourceDtoSourceEnum) => void;
  reload: () => void;
  hasSubscribe?: boolean;
  isDesktop: boolean;
  priceProps: PriceProps;
}

export const ProductDesktopLayout = ({
  product,
  source,
  platform,
  setPlatform,
  hasSubscribe,
  reload,
  isDesktop,
  priceProps,
}: ProductDesktopLayoutProps) => {
  const {
    isLoading,
    activeVariant,
    isBlur,
    blurPrice,
    showSelectPlatformPrompt,
  } = priceProps;

  return (
    <Flex direction="row" gap="3">
      <div className={css.contentFlexText}>
        <Flex direction="column" gap="3">
          <ProductContentDescription product={product} />
          <ProductPriceDetails {...priceProps} />
        </Flex>
      </div>

      {hasSubscribe && (
        <div className={css.contentFlex}>
          <Flex direction="column" gap="3">
            <ProductPriceSource
              source={source}
              platform={platform}
              setPlatform={setPlatform}
              reload={reload}
              isDesktop
            />
            <ProductInfo
              isLoading={isLoading}
              isBlur={isBlur}
              blurPrice={blurPrice}
              showSelectPlatformPrompt={showSelectPlatformPrompt}
              activeVariant={activeVariant}
              isDesktop={isDesktop}
            />
          </Flex>
        </div>
      )}
    </Flex>
  );
};
